module.exports = __webpack_public_path__ + "img/green-90rotate-icon.7aa7ff60.png";